export default __webpack_public_path__ + "static/media/cp_geo_bh.aba0cbf3.svg";